import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from '../../styles/common/LockerModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface LockerModalProps {
    show: boolean;
    onHide: () => void;
}

const LockerModal: React.FC<LockerModalProps> = ({
    show,
    onHide,
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            scrollable={true}
            className={styles.faqModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Casillero Internacional
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="faq-content">
                    <h5>Tu Dirección en USA</h5>
                    <p>Al registrarte, obtienes un número de casillero único. Puedes comprar en tiendas como Amazon, eBay o Walmart y enviar tus compras a nuestros almacenes en Miami.</p>

                    <h5>¿Cómo usarlo?</h5>
                    <p>Al realizar tu compra, utiliza la siguiente estructura de dirección:</p>
                    <div style={{ background: '#f1f5f9', padding: '15px', borderRadius: '12px', marginBottom: '15px' }}>
                        <strong>Full Name:</strong> Tu Nombre + (Código de Casillero)<br />
                        <strong>Address Line 1:</strong> 8952 NW 24th Terrace<br />
                        <strong>City:</strong> Doral<br />
                        <strong>State:</strong> FL<br />
                        <strong>Código Postal:</strong> 33172
                    </div>

                    <h5>Consolidación de Paquetes</h5>
                    <p>Recibimos múltiples paquetes por separado y, si lo solicitas, los agrupamos en una sola caja. Esto reduce significativamente el costo de envío final a Venezuela al evitar el cobro mínimo por paquete individual.</p>

                    <h5>Notificaciones Automáticas</h5>
                    <p>Cada vez que recibamos un paquete a tu nombre, te enviaremos una notificación por correo electrónico con las fotos y detalles del peso para que decidas cuándo enviarlo.</p>

                    <h5>Almacenamiento Gratuito</h5>
                    <p>Ofrecemos hasta <strong>30 días de almacenamiento gratuito</strong> en nuestro almacén para que tengas tiempo de completar todas tus compras antes de consolidar.</p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={onHide}
                    className={modalStyles.closeBtn}
                >
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LockerModal;
